import Vue from 'vue'
import App from './App.vue'
import 'ant-design-vue/dist/antd.css'
import Antd from 'ant-design-vue'
import router from './router'
import { server } from './providers/http-service'
import store from './store'
import * as filters from './filters/index' 
import defines from './config'

Object.keys(filters).forEach(item => Vue.filter(item, filters[item])) 



Vue.config.productionTip = false
Vue.use(Antd)
//定义全局变量
Vue.prototype.$http = server;
Vue.prototype.$defines = defines


router.beforeEach((to, from, next) => {
  console.log("From:",from);
  console.log("To:",to);
  console.log(to.meta.roles);
  next()
  // if (to.matched.forEach(record => {
  //     console.log("record:", record)

  //     console.log(record.meta.roles);
  //     return permissionCode.indexOf(record.meta.permission) == -1
  // })) {
  //     next('/notFound')
  // } else {
  //     next()
  // }
})

new Vue({
  router: router,
  store,
  render: h => h(App),
}).$mount('#app')
